import React, { useState } from 'react';
import Footer from '../../../components/Footer';
import VegIcon from '../../../components/VegIcon';
import './ComicCrunch.css';

import DEFAULT_LOGO from '../../../assets/defaults/logo-default.jpg';
import DEFAULT_ITEM from '../../../assets/defaults/item-default.jpg';
import RestaurantLogo from '../../../components/RestaurantLogo';
import MenuItemImage from '../../../components/MenuItemImage';
import OffersRenderer from '../../../components/OffersRenderer';

const ComicCrunch = ({ data }) => {
    const restaurant = data?.restaurant || {};
    const menus = data?.menus || [];
    const [activeMenuId, setActiveMenuId] = useState(menus[0]?.id);
    const [selectedItem, setSelectedItem] = useState(null);

    const activeMenu = menus.find(m => m.id === activeMenuId) || menus[0];

    if (!data) return <div className="comic-loading">POW! Loading...</div>;

    return (
        <div className="comic-root">

            {/* RESTAURANT HEADER */}
            <header className="comic-header">
                <div className="comic-hero">
                    <div className="comic-logo-burst">
                        <RestaurantLogo src={restaurant.logoUrl} className="comic-logo" />
                    </div>
                    <h1 className="comic-title">{restaurant.name || 'Hero Eats'}</h1>
                    <div className="comic-tagline-bubble">
                        <p>{restaurant.description || 'Action-packed flavors in every bite!'}</p>
                    </div>
                </div>
            </header>

            {/* Offers / Notes */}
            <OffersRenderer offers={data?.offers} />

            {/* CATEGORY NAVIGATION */}
            {menus.length > 1 && (
                <div className="comic-nav-container">
                    <nav className="comic-nav">
                        {menus.map(menu => (
                            <button
                                key={menu.id}
                                className={`comic-tab ${activeMenuId === menu.id ? 'active' : ''}`}
                                onClick={() => setActiveMenuId(menu.id)}
                            >
                                {menu.name}
                            </button>
                        ))}
                    </nav>
                </div>
            )}

            {/* MENU CATEGORIES & ITEMS */}
            <main className="comic-main">
                {activeMenu && activeMenu.categories?.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0)).map(cat => (
                    <section key={cat.id} className="comic-category">
                        <h2 className="comic-cat-title"><span>{cat.name}</span></h2>
                        <div className="comic-grid">
                            {cat.items?.map(item => (
                                <ComicItem key={item.id} item={item} onClick={() => setSelectedItem(item)} />
                            ))}
                        </div>
                    </section>
                ))}
            </main>

            {/* MENU ITEM DETAIL MODAL */}
            {selectedItem && (
                <div className="comic-modal-overlay" onClick={() => setSelectedItem(null)}>
                    <div className="comic-modal" onClick={e => e.stopPropagation()}>
                        <button className="comic-modal-close" onClick={() => setSelectedItem(null)}>CLOSE!</button>
                        <div className="comic-modal-img">
                            <MenuItemImage src={selectedItem.imageUrl} alt={selectedItem.name} />
                            {(selectedItem.isVeg !== undefined && selectedItem.isVeg !== null) && (
                                <div className={`comic-diet-badge ${selectedItem.isVeg ? 'veg' : 'nonveg'}`}>
                                    <span className="comic-veg-dot"></span>
                                </div>
                            )}
                        </div>
                        <div className="comic-modal-body">
                            <h3>{selectedItem.name}</h3>
                            {Number(selectedItem.price) > 0 && (
                                <p className="comic-modal-price">₹{Number(selectedItem.price).toLocaleString()}!</p>
                            )}
                            <p className="comic-modal-desc">{selectedItem.description}</p>

                            {selectedItem.variants && selectedItem.variants.length > 0 ?
                                <div className="comic-modal-variants">
                                    <h4>Variants</h4>
                                    {selectedItem.variants?.filter(v => v.isActive).map(v => (
                                        <div key={v.id} className="comic-v-row">
                                            <span>{v.name}</span>
                                            <span className="comic-v-price">
                                                {Number(v.price) > 0 ? `₹${Number(v.price).toLocaleString()}` : ''}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                                : null
                            }
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

const ComicItem = ({ item, onClick }) => {
    if (!item) return null;

    return (
        <div className={`comic-card ${!item.isAvailable ? 'sold-out' : ''}`} onClick={onClick} style={{ cursor: 'pointer' }}>
            <div className="comic-card-img-wrap">
                <MenuItemImage src={item.imageUrl} alt={item.name} className="comic-img" />
                {Number(item.price) > 0 && (
                    <div className="comic-price-zap">₹{Number(item.price).toLocaleString()}</div>
                )}
                {(item.isVeg !== undefined && item.isVeg !== null) && (
                    <div className={`comic-diet-badge ${item.isVeg ? 'veg' : 'nonveg'}`}>
                        <span className="comic-veg-dot"></span>
                    </div>
                )}
            </div>

            <div className="comic-card-body">
                <h3 className="comic-item-name">{item.name}</h3>
                <p className="comic-item-desc" title={item.description}>{item.description}</p>

                {item.tags && (
                    <div className="comic-tags">
                        {item.tags.map(t => <span key={t} className="comic-tag">!{t}</span>)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ComicCrunch;
